
export enum PatientPermissions {
  'PATIENT.CREATE' = 'patientCreate',
  'PATIENT.MODIFY' = 'patientModify'
}

export class PermissionSchemaConstants {
  public static schemaWorkflowWrite: string = 'WORKFLOW.WRITE';
  public static schemaWorkflowAnalysisRemove: string = 'WORKFLOW.ANALYSIS.REMOVE';
  public static shcemaWorkflowAnalysisRevise: string = 'WORKFLOW.ANALYSIS.REVISE';
  public static schemaWorkflowBackAction: string = 'WORKFLOW.BACK.ACTION';
  public static shcemaDiagnosticOrderWrite: string = "DIAGNOSTICORDER.WRITE";

  public static schemaOptellumContextLaunch: string = 'OPTELLUM.LAUNCH';
  public static schemaPanCancerDashboardRead: string = 'PANCANCER.DASHBOARD.READ';
  public static schemaPanCancerDashboardWrite: string = 'PANCANCER.DASHBOARD.WRITE';
  public static schemaPanCancerMDTRead: string = 'PANCANCER.MDT.READ';
  public static schemaPanCancerMDTWrite: string = 'PANCANCER.MDT.WRITE';
  public static schemaPanCancerEventRead: string = 'EVENT.READ';
  public static schemaPanCancerEventWrite: string = 'EVENT.WRITE';
  public static schemaAdminOrgEdit: string = 'ADMIN.ORGANIZATION.EDIT';
  public static schemaAdminOrgCreate: string = 'ADMIN.ORGANIZATION.CREATE';
  public static schemaAdminOrgActivate: string = 'ADMIN.ORGANIZATION.ACTIVATE';
  public static schemaAdminOrgWorklist: string = 'ADMIN.ORGANIZATION.WORKLIST';
  public static reportUpload: string = 'ADMIN.REPORT.UPLOAD';
  public static schemaAdminOrgWorklistCreate: string = 'ADMIN.ORGANIZATION.WORKLIST.CREATE';
  public static schemaAdminOrgAccessToAll: string = 'ADMIN.ORGANIZATION.ACCESS.TO.ALL';
  public static schemaAdminOrgRead: string = 'ADMIN.ORGANIZATION.READ';
  public static schemaReportWrite: string = 'REPORT.WRITE';

  private static valueMap = PermissionSchemaConstants.buildValues();

  private static buildValues(): Map<string, string> {
    const map = new Map<string, string>();

    // Curation-Item schemas
    map.set('curationItemWrite', 'CURATIONITEM.WRITE');
    map.set('curationItemApprove', 'CURATIONITEM.APPROVE');

    // Note schemas
    map.set('noteWrite', 'NOTE.WRITE');

    // Reports-And-Documents schemas
    map.set('reportsAndDocsWrite', 'REPORTSANDDOCUMENTS.WRITE');

    //Reports Write Schema
    map.set('reportsWrite', PermissionSchemaConstants.schemaReportWrite);

    // Test-Specimen schemas
    map.set('testSpecimenWrite', 'TEST.SPECIMEN.WRITE');

    // Workflow schemas
    map.set('workflowWrite', PermissionSchemaConstants.schemaWorkflowWrite);

    // Workflow-Analysis schemas
    map.set('workflowAnalysisRemove', PermissionSchemaConstants.schemaWorkflowAnalysisRemove);


    // patient schemas
    map.set(PatientPermissions['PATIENT.CREATE'], 'PATIENT.CREATE');
    map.set(PatientPermissions['PATIENT.MODIFY'], 'PATIENT.MODIFY');


    // pan cancer schemas
    map.set('optellumContextLaunch', PermissionSchemaConstants.schemaOptellumContextLaunch);
    map.set('panCancerDashboardRead', PermissionSchemaConstants.schemaPanCancerDashboardRead);
    map.set('panCancerDashboardWrite', PermissionSchemaConstants.schemaPanCancerDashboardWrite);
    map.set('panCancerMDTRead', PermissionSchemaConstants.schemaPanCancerMDTRead);
    map.set('panCancerMDTWrite', PermissionSchemaConstants.schemaPanCancerMDTWrite);
    map.set('panCancerEventRead', PermissionSchemaConstants.schemaPanCancerEventRead);
    map.set('panCancerEventWrite', PermissionSchemaConstants.schemaPanCancerEventWrite);

    map.set('adminOrgRead', PermissionSchemaConstants.schemaAdminOrgRead);
    map.set('adminOrgEdit', PermissionSchemaConstants.schemaAdminOrgEdit);
    map.set('adminOrgCreate', PermissionSchemaConstants.schemaAdminOrgCreate);
    map.set('adminOrgActivate', PermissionSchemaConstants.schemaAdminOrgActivate);
    map.set('adminOrgWorklist', PermissionSchemaConstants.schemaAdminOrgWorklist);
    map.set('adminOrgWorklistCreate', PermissionSchemaConstants.schemaAdminOrgWorklistCreate);
    map.set('adminAccessToAll', PermissionSchemaConstants.schemaAdminOrgAccessToAll);

    // report template permissions
    map.set('reportUpload', PermissionSchemaConstants.reportUpload);
    return map;
  }

  public static getPermissionSchema(key: string): string {
    return PermissionSchemaConstants.valueMap.get(key);
  }

}
